StudentTargets = new (function () {
  this.bindEvents = () => {
    $(".submit-student-targets").on("click", function () {
      const data = $(".student-targets-form #subject_current_group").val();
      if (!data) return;
      const [subject, currentYear] = data.split(" - Year ");

      $(".student-targets-form #st-current-year-group").val(currentYear);
      $(".student-targets-form #st-subject").val(subject);
    });

    $(".student-targets-list #st-level").on("change", function () {
      $(".student-targets-list .st-level-sy select").select2("val", $(this).val());
    });

    $(".student-targets-list .st-target-grade").on("change", setCaoPoints);

    $("#new-student-targets-filter").on("ajax:success", function () {
      $(".student-targets-form .form-control.st-target-grade").select2({
        placeholder: "Select Grade",
        minimumResultsForSearch: Infinity,
      });
      $(".student-targets-form .form-control.st-target-level").select2({
        placeholder: "Select Level",
        minimumResultsForSearch: Infinity,
      });
      $(".student-targets-list .st-target-grade").on("change", setCaoPoints);
    });
  };

  this.setSelects = () => {
    $(".student-targets-form #subject_current_group").select2({
      allowClear: false,
    });
    $("#new-student-targets-filter #tutor-group-filter")
      .select2({
        placeholder: "Any tutor group",
        minimumResultsForSearch: Infinity,
        ajax: {
          dataType: "json",
          url: `/tutor_groups/autocomplete`,
          delay: 250,
          data: (params) => ({
            ...params,
            current_year: $("input[type='hidden']#hidden_year_group").val(),
            subject: $("input[type='hidden']#hidden_subject").val(),
          }),
        },
      })
      .on("select2:selecting select2:clearing", function (e) {
        if (!confirm("Any previously unsaved changes you made will be lost. Do you wish to proceed?")) {
          e.preventDefault();
          return;
        }
      });
    $(".student-targets-form .form-control.st-target-grade").select2({
      placeholder: "Select Grade",
      minimumResultsForSearch: Infinity,
    });
    $(".student-targets-form .form-control.st-target-level").select2({
      placeholder: "Select Level",
      minimumResultsForSearch: Infinity,
    });
    $(".student-targets-form #st-level").select2({
      placeholder: "Level",
      minimumResultsForSearch: Infinity,
      allowClear: false,
    });
  };

  function setCaoPoints() {
    let index = $(this).attr("data-index");
    $(".student-targets-list #st-cao-point-" + index).val($(this).children("option:selected").attr("data-cao-point"));
  }
})();
